import {
	ADD_ANAGRAFICA_FAIL,
	ADD_ANAGRAFICA_START,
	ADD_ANAGRAFICA_SUCCESS,
	ADD_NOTE_TO_DIARIO_FAIL,
	ADD_NOTE_TO_DIARIO_START,
	ADD_NOTE_TO_DIARIO_SUCCESS, GET_ALLEGATI_FAIL,
	GET_ALLEGATI_START, GET_ALLEGATI_SUCCESS,
	GET_ANAGRAFICA_ASSOCIATA_FAIL,
	GET_ANAGRAFICA_ASSOCIATA_START,
	GET_ANAGRAFICA_ASSOCIATA_SUCCESS,
	GET_ANAGRAFICA_FAIL,
	GET_ANAGRAFICA_START,
	GET_ANAGRAFICA_SUCCESS,
	GET_RELAZIONI_FAIL,
	GET_RELAZIONI_START,
	GET_RELAZIONI_SUCCESS,
	RESET_ANAGRAFICA,
	SEARCH_ANAGRAFICA_FAIL,
	SEARCH_ANAGRAFICA_START,
	SEARCH_ANAGRAFICA_SUCCESS,
	SET_ANAGRAFICA,
	UPDATE_ANAGRAFICA_FAIL,
	UPDATE_ANAGRAFICA_START,
	UPDATE_ANAGRAFICA_SUCCESS,
	SET_DIARIO
} from "./actions/ActionTypes";

export const initAnagraficaState = () => {
	return {
		anagrafica: {},
		loadingGetAnagrafica: true,
		errorGetAnagrafica: "",
		searchedAnagrafica: [],
		loadingSearchAnagrafica: false,
		errorSearchAnagrafica: "",
		loadingUpdateAnagrafica: true,
		errorUpdateAnagrafica: "",
		idSoggetto: "",
		loadingAddAnagrafica: true,
		errorAddAnagrafica: "",
		
		relazioni: [],
		relazioniMap: {},
		loadingGetRelazioni: true,
		errorGetRelazioni: "",
		
		pazientiAssociati: [],
		loadingPazientiAssociati: true,
		errorPazientiAssociati: "",
		
		loadingAddNote: true,
		errorAddNote: "",
		
		allegati: [],
		loadingGetAllegati: true,
		errorGetAllegati: "",
		
		diario: {}
	}
}

export const ANAGRAFICA_INITIAL_STATE = {}

export const AnagraficaReducer = (state = ANAGRAFICA_INITIAL_STATE, action) => {
	/*console.log(action);*/
	switch (action.type) {
		case GET_ANAGRAFICA_START:
			return {
				...state,
				anagrafica: {},
				idSoggetto: "",
				loadingGetAnagrafica: true,
				errorGetAnagrafica: "",
			}
		case GET_ANAGRAFICA_SUCCESS:
			return {
				...state,
				anagrafica: action.payload,
				loadingGetAnagrafica: false,
				errorGetAnagrafica: "",
			}
		case GET_ANAGRAFICA_FAIL:
			return {
				...state,
				anagrafica: {},
				loadingGetAnagrafica: false,
				errorGetAnagrafica: action.error,
			}
		case SEARCH_ANAGRAFICA_START:
			return {
				...state,
				searchedAnagrafica: [],
				loadingSearchAnagrafica: true,
				errorSearchAnagrafica: "",
			}
		case SEARCH_ANAGRAFICA_SUCCESS:
			return {
				...state,
				searchedAnagrafica: action.payload,
				loadingSearchAnagrafica: false,
				errorSearchAnagrafica: "",
			}
		case SEARCH_ANAGRAFICA_FAIL:
			return {
				...state,
				searchedAnagrafica: [],
				loadingSearchAnagrafica: false,
				errorSearchAnagrafica: action.error,
			}
		case UPDATE_ANAGRAFICA_START:
			return {
				...state,
				loadingUpdateAnagrafica: true,
				errorUpdateAnagrafica: "",
				anagrafica: {},
			}
		case UPDATE_ANAGRAFICA_SUCCESS:
			return {
				...state,
				loadingUpdateAnagrafica: false,
				errorUpdateAnagrafica: "",
				anagrafica: action.payload,
			}
		case UPDATE_ANAGRAFICA_FAIL:
			return {
				...state,
				loadingUpdateAnagrafica: false,
				errorUpdateAnagrafica: action.error,
				anagrafica: {},
			}
		case SET_ANAGRAFICA:
			return {
				...state,
				anagrafica: action.payload,
				idSoggetto: action.payload.idSoggetto,
			}
		
		case RESET_ANAGRAFICA:
			return {
				...state,
				loadingGetAnagrafica: true,
				errorGetAnagrafica: "",
			}
		case ADD_ANAGRAFICA_START:
			return {
				...state,
				idSoggetto: "",
				loadingAddAnagrafica: true,
				errorAddAnagrafica: "",
			}
		case ADD_ANAGRAFICA_SUCCESS:
			return {
				...state,
				anagrafica: action.payload,
				idSoggetto: action.payload,
				loadingAddAnagrafica: false,
				errorAddAnagrafica: "",
			}
		case ADD_ANAGRAFICA_FAIL:
			return {
				...state,
				idSoggetto: "",
				loadingAddAnagrafica: false,
				errorAddAnagrafica: action.error,
			}
		case GET_RELAZIONI_START:
			return {
				...state,
				relazioni: [],
				relazioniMap: {},
				loadingGetRelazioni: true,
				errorGetRelazioni: "",
			}
		case GET_RELAZIONI_SUCCESS:
			return {
				...state,
				relazioni: action.payload,
				relazioniMap: {...state.relazioniMap, ...action.map},
				loadingGetRelazioni: false,
				errorGetRelazioni: "",
			}
		case GET_RELAZIONI_FAIL:
			return {
				...state,
				relazioni: [],
				relazioniMap: {},
				loadingGetRelazioni: false,
				errorGetRelazioni: action.error,
			}
		case GET_ANAGRAFICA_ASSOCIATA_START:
			return {
				...state,
				pazientiAssociati: [],
				loadingPazientiAssociati: true,
				errorPazientiAssociati: "",
			}
		case GET_ANAGRAFICA_ASSOCIATA_SUCCESS:
			return {
				...state,
				pazientiAssociati: action.payload,
				loadingPazientiAssociati: false,
				errorPazientiAssociati: "",
			}
		case GET_ANAGRAFICA_ASSOCIATA_FAIL:
			return {
				...state,
				pazientiAssociati: [],
				loadingPazientiAssociati: false,
				errorPazientiAssociati: action.error,
			}
		case ADD_NOTE_TO_DIARIO_START:
			return {
				...state,
				loadingAddNote: true,
				errorAddNote: "",
			}
		case ADD_NOTE_TO_DIARIO_SUCCESS:
			return {
				...state,
				loadingAddNote: false,
				errorAddNote: "",
			}
		case ADD_NOTE_TO_DIARIO_FAIL:
			return {
				...state,
				loadingAddNote: false,
				errorAddNote: action.error,
			}
		case GET_ALLEGATI_START:
			return {
				...state,
				allegati: [],
				loadingGetAllegati: true,
				errorGetAllegati: "",
			}
		case GET_ALLEGATI_SUCCESS:
			return {
				...state,
				allegati: action.payload,
				loadingGetAllegati: false,
				errorGetAllegati: "",
			}
		case GET_ALLEGATI_FAIL:
			return {
				...state,
				allegati: [],
				loadingGetAllegati: false,
				errorGetAllegati: action.error,
			}
		case SET_DIARIO:
			return {
				...state,
				diario: action.payload
			}
		
		default:
			return state;
	}
}
